const eventListenerFactory = require('@ordergroove/brandy/src/app/core/directives/event.listener.factory');

angular.module('msi.products')
  .directive('ogOnChangeProduct', eventListenerFactory('ogOnChangeProduct'));
